import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Notification } from '../interfaces/models/notification';
import { NotificationRecipient } from '../interfaces/models/notification-recipient';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private http: HttpClient) {}

  // This function is called on a timer. It is used to periodically check if a Notification should be constructed
  // for a User.
  public pollForNotifications(query = {}) {
    return this.http.get('/api/v2/notification/pollForNotifications', {
      params: query
    });
  }

  public getNotifications(query = {}) {
    return this.http.get('/api/v2/notification/getNotifications', {
      params: query
    });
  }

  public addEditNotification(notification: Notification) {
    return this.http.post(
      '/api/v2/notification/addEditNotification',
      notification
    );
  }

  public addEditNotificationRecipients(
    NotificationId: number,
    notificationRecipients: NotificationRecipient[]
  ) {
    return this.http.post(
      `/api/v2/notification/${NotificationId}/addEditNotificationRecipients`,
      notificationRecipients
    );
  }

  public archiveNotificationRecipient(
    notificationRecipient: NotificationRecipient
  ) {
    return this.http.post(
      `/api/v2/notification/archiveNotificationRecipient`,
      notificationRecipient
    );
  }
}
